import { useNavigate } from 'react-router-dom';
import { AddCircle } from '@mui/icons-material';
import { Box, Divider } from '@mui/material';
import { InfoItem, SidebarItem } from '/src/components';
import { Asset } from '/src/lib/models';

export type AssetPaymentScheduleProps = {
  /**
   * Whether this component is visible
   */
  open: boolean;
  /**
   * Toggles component visibility
   * @returns void
   */
  toggleOpen: () => void;
  /**
   * Asset to display payment schedule for
   */
  asset?: Asset;
};

export const AssetPaymentSchedule: React.FC<AssetPaymentScheduleProps> = ({ asset, open, toggleOpen }) => {
  const navigate = useNavigate();

  return (
    <SidebarItem
      title="Payment Schedule"
      open={open}
      toggleOpen={toggleOpen}
      buttonProps={{
        label: 'Record Payment',
        icon: <AddCircle style={{ color: 'white' }} className="material-icons md-icon" />,
        onClick: () => navigate('/payments/create'),
      }}
      resolved={!!asset}
    >
      <InfoItem title="Payment Schedule" value={asset?.paymentSchedule} date />
      <Divider />
      <InfoItem title="Next Payment" value={asset?.nextDate} date />
      {asset?.loan?.isOwned && (
        <Box>
          <Divider />
          <InfoItem title="Late After" value={asset?.startDate} date />
          <Divider />
          <InfoItem title="Buyback Date" value={asset?.endDate} date />
        </Box>
      )}
    </SidebarItem>
  );
};
